import React from "react";

/**
 * Note / text capture line-art icon — Lucide "pencil-line" stroke glyph.
 * Same purple stroke convention as CaptureFrame and the Capture thumb glyphs.
 */
const PencilLineArt = ({
  color = "#8F38EF",
  width = 24,
  height = 24,
  strokeWidth = 2,
  style,
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    style={{ width, height, flexShrink: 0, ...style }}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-pencil-line"
    aria-hidden="true"
    {...rest}
  >
    <path d="M13 21h8" />
    <path d="m15 5 4 4" />
    <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" />
  </svg>
);

export default PencilLineArt;
